import { RingSpinner } from '@/shared/components/loader/ring-spinner';

import type { PendingDiscoveryAction } from '../../stores/pending-discovery-action-store';
import { SeedPostImage } from '../seed-post/seed-post-image';
import { AssistantAvatar, UserMessageBubble } from './primitives';

export function PendingDiscoveryActionMessage({ action }: { action: PendingDiscoveryAction }) {
  return (
    <div className="flex flex-col gap-6">
      <UserMessageBubble>
        {action.type === 'prompt' ? (
          <p className="text-muted text-sm">{action.message}</p>
        ) : (
          <SeedPostImage posts={action.seedPosts} />
        )}
      </UserMessageBubble>
      <div className="flex items-start gap-3">
        <AssistantAvatar />
        <div className="mt-1 flex items-center gap-2">
          <RingSpinner className="size-4" />
          <span className="text-primary text-sm">Analyzing your request...</span>
        </div>
      </div>
    </div>
  );
}
